<template>
    <div>
        <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0 text-center" style="font-size: 26px">Detalle de la Venta #{{datos.id}}</p>
            </template>
            <b-card-text>
                <div><b>Realizado Por:</b> {{datos.nombre_usuario}}</div>
                <div><b>Fecha:</b> {{datos.created_at}}</div>
                <div><b>Nombre Cliente:</b> {{datos.cliente_nombre}}</div>
                <div><b>Documento:</b> {{datos.cliente_nit}}</div>
                <div><b>Telefono:</b> {{datos.cliente_telefono}}</div>
                <div><b>Dirección:</b> {{datos.cliente_direccion}}</div>
                <div><b>Departamento:</b> {{datos.nombre_departamento_venta}}</div>
                <div><b>Ciudad:</b> {{datos.nombre_ciudad_venta}}</div>
            </b-card-text>
            <b-card-text bg-variant="secondary">
                <p class="mb-0 text-center" style="font-size: 26px">Items De la Venta</p>
            </b-card-text>
            <b-card-text>
                <itemsComponent :productos="productos" :datos="datos"/>
            </b-card-text>
            <template v-slot:footer>
                <b-button id="volver" variant="danger" 
                class="text-white mr-2" 
                :to="{name: 'ListadoVentas'}">
                    Volver Listado
                </b-button>
            
                <b-button variant="info" 
                class="text-white" 
                @click.prevent="printWindow()">
                    Imprimir
                </b-button>
            </template>
        </b-card>
    </div>
</template>
<script>
import itemsComponent from './ItemsComponent.vue'
import { mapState, mapMutations} from 'vuex'
export default {
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
    },
    data(){
        return{
            datos: {},
            productos: [],
            id: this.$route.params.id,
        }
    },
    components: {
        itemsComponent
    },
    created(){
        this.getVentaInfo();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getVentaInfo(){
            this.setLoading(true)
            await this.$conectar.post('punto-venta/get-venta-info', {id: this.id})
            .then(response =>{
                this.datos = response.data.ventaDetail;
                this.productos = response.data.ventaDetail.items;
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
            
        },
        printWindow() {
            window.print();
        }
    }
}
</script>
<style scoped>
.widthPersonalized{
    max-width: 400px;
}
.precio{
    min-width: 600px;
}
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.singleLines {
  white-space: nowrap !important;
  overflow: hidden !important;
}
@media print {
  button {
    display: none;
  }
  #volver{
    display: none;
  }
}


</style>